import React from 'react';
import { connect } from 'react-redux';
import Txt from '../../../inputs/textInput.js';
import Lbl from '../../../inputs/label.js';
import objectAssign from 'object-assign';
import { updateGroupForm } from '../../../../actions/group.js';
import { ValidMe } from '../../../../businessLogic/validation.js';
import { clone } from '../../../../reducers/helper.js';

@connect(mapStateToProps)
export default class CenterPanelUpdate extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      organisations: props.organisations,
      groupForm: props.groupForm,
      postCallSurveOptions: APP.LANGUAGE.PostCallSurvey.Options,
      videoCallQualityProfiles: props.videoCallQualityProfiles,
    };
  }

  groupUpdated = (property, value) => {
    let val = value;
    var cloneGroup = clone(this.state.groupForm);
    property.map((option, i) => {
      cloneGroup[option] = value[i];
    }, this);
    return cloneGroup;
  };

  groupNameChanged = (value) => {
    this.props.dispatch(updateGroupForm(this.groupUpdated(['name'], [value])));
  };
  postCallSurveSelectedChanged = (option) => {
    if (option && option.Id != undefined) {
      this.hideDisplaySurveyOptions(option.Id);
      //we will have view also so we may have to set the name
      this.props.dispatch(updateGroupForm(this.groupUpdated(['postCallOptionId'], [option.Id])));
    }
  };
  hideDisplaySurveyOptions = (id) => {
    if (id == 1) {
      this.setState({
        displayPostCallUrl: true,
        displayProviderUrl: false,
        displayCallerGuestUrl: false,
      });
    } else if (id == 2) {
      this.setState({
        displayPostCallUrl: false,
        displayProviderUrl: true,
        displayCallerGuestUrl: true,
      });
    } else {
      //either option.id==0 or anyother
      this.setState({
        displayPostCallUrl: false,
        displayProviderUrl: false,
        displayCallerGuestUrl: false,
      });
    }
  };
  purgeCallerChanged = () => {
    this.props.dispatch(
      updateGroupForm(this.groupUpdated(['purgeCallerDetails'], [!this.props.groupForm.purgeCallerDetails]))
    );
  };
  groupEmailChanged = (value) => {
    this.props.dispatch(updateGroupForm(this.groupUpdated(['email'], [value])));
  };

  postCallUrlChanged = (value) => {
    this.props.dispatch(updateGroupForm(this.groupUpdated(['postCallUrl'], [value])));
  };

  providerUrlChanged = (value) => {
    this.props.dispatch(updateGroupForm(this.groupUpdated(['providerUrl'], [value])));
  };

  callerGuestUrlChanged = (value) => {
    this.props.dispatch(updateGroupForm(this.groupUpdated(['callerGuestUrl'], [value])));
  };
  callQualitySelectedChanged = (option) => {
    if (option && option.id) {
      this.props.dispatch(updateGroupForm(this.groupUpdated(['videoCallQualityId'], [option.id])));
    }
  };
  UNSAFE_componentWillReceiveProps = (props) => {
    //THIS EVENT TRIGGERS WHEN THE PARENT UPDATES DATA
    this.hideDisplaySurveyOptions(props.groupForm.postCallOptionId); //setting display option based on the call back url option
    this.setState({
      organisations: props.organisations,
      groupForm: props.groupForm,
      videoCallQualityProfiles: props.videoCallQualityProfiles,
    });
  };
  render() {
    var postCallOptionId = this.state.groupForm.postCallOptionId < 0 ? 0 : this.state.groupForm.postCallOptionId; //setting to default 0;
    var postCallOption = this.state.postCallSurveOptions
      ? this.state.postCallSurveOptions.find((x) => x.Id == postCallOptionId)
      : undefined;
    var postCallSurveOptionValue = postCallOption ? postCallOption.Name : '';

    var videoCallQuality = this.state.videoCallQualityProfiles
      ? this.state.videoCallQualityProfiles.find((x) => x.id == this.state.groupForm.videoCallQualityId)
      : undefined;
    var videoCallQualityValue = videoCallQuality ? videoCallQuality.description : '';

    let elementsToRender = '';

    if (this.props.modalVisible) {
      elementsToRender = (
        <div className="ui form">
          <div className="mrbl">
            <h4 className="mrbl">{APP.LANGUAGE.CreateUpdateGroup.BasicDetailsHeading}</h4>
          </div>

          <ValidMe
            validmefor="length@3-48"
            validmemessage={APP.LANGUAGE.Errors.groupValidNameLength}
            group="updateGroupForm"
          >
            <Txt
              focusme="true"
              tabIndex="1"
              noTitle
              value={this.state.groupForm.name}
              onChange={this.groupNameChanged}
              placeholder={APP.LANGUAGE.CreateUpdateGroup.NamePlaceholder}
            />
          </ValidMe>

          <ValidMe validmefor="email" validmemessage={APP.LANGUAGE.Errors.InvalidEmail} group="updateGroupForm">
            <Txt
              tabIndex="2"
              value={this.state.groupForm.email}
              placeholder={APP.LANGUAGE.CreateUpdateGroup.EmailPlaceholder}
              noTitle
              onChange={this.groupEmailChanged}
            />
          </ValidMe>
          <div className="mrbl">
            <h4 className="mrbl">{APP.LANGUAGE.CreateUpdateGroup.MeetingRoomsHeading}</h4>
          </div>

          <ValidMe
            validmefor="dropdown"
            group="updateGroupForm"
            defaulttext={APP.LANGUAGE.CreateUpdateGroup.CallQualityPlaceHolder}
            validmemessage={APP.LANGUAGE.Errors.CreateGroupNonSelectedCallQualityError}
          >
            <Txt
              dropdown
              tabIndex="3"
              text={APP.LANGUAGE.CreateUpdateGroup.CallQualityPlaceHolder}
              selectedItemPlaceholder={APP.LANGUAGE.CreateUpdateGroup.SelectedCallQualityPlaceHolder}
              value={videoCallQualityValue}
              fields={'description'}
              options={this.state.videoCallQualityProfiles}
              onChange={this.callQualitySelectedChanged}
            />
          </ValidMe>

          <ValidMe
            validmefor="dropdown"
            group="updateGroupForm"
            defaulttext={APP.LANGUAGE.CreateUpdateGroup.PostCallSurveyPlaceholder}
            validmemessage={APP.LANGUAGE.Errors.CreateGroupNonSelectedSurveyError}
          >
            <Txt
              dropdown
              tabIndex="4"
              text={APP.LANGUAGE.CreateUpdateGroup.PostCallSurveyLabel}
              onChange={this.postCallSurveSelectedChanged}
              selectedItemPlaceholder={APP.LANGUAGE.CreateUpdateGroup.SelectedSurveyOptionPlaceHolder}
              value={postCallSurveOptionValue}
              fields={'Name'}
              options={this.state.postCallSurveOptions}
            />
          </ValidMe>

          <ValidMe validmefor="urlOptional" validmemessage={APP.LANGUAGE.Errors.InvalidUrl} group="updateGroupForm">
            <Txt
              tabIndex="5"
              show={this.state.displayPostCallUrl}
              value={this.state.groupForm.postCallUrl}
              titlePlaceholder={APP.LANGUAGE.PostCallSurvey.SameInformationSurvePageLabel}
              placeholder={APP.LANGUAGE.PostCallSurvey.SameInformationSurvePageLabelPlaceHolder}
              noTitle
              onChange={this.postCallUrlChanged}
            />
          </ValidMe>
          <ValidMe validmefor="urlOptional" validmemessage={APP.LANGUAGE.Errors.InvalidUrl} group="updateGroupForm">
            <Txt
              tabIndex="5"
              show={this.state.displayProviderUrl}
              titlePlaceholder={APP.LANGUAGE.PostCallSurvey.DifferentSurveyGroupMemberUrlLabel}
              value={this.state.groupForm.providerUrl}
              placeholder={APP.LANGUAGE.PostCallSurvey.DifferentSurveyGroupMemberUrlPlaceHolder}
              noTitle
              onChange={this.providerUrlChanged}
            />
          </ValidMe>
          <ValidMe validmefor="urlOptional" validmemessage={APP.LANGUAGE.Errors.InvalidUrl} group="updateGroupForm">
            <Txt
              tabIndex="6"
              titlePlaceholder={APP.LANGUAGE.PostCallSurvey.DifferentSurveyOtherParticipantLabel}
              show={this.state.displayCallerGuestUrl}
              value={this.state.groupForm.callerGuestUrl}
              placeholder={APP.LANGUAGE.PostCallSurvey.DifferentSurveyOtherParticipantPlaceHolder}
              noTitle
              onChange={this.callerGuestUrlChanged}
            />
          </ValidMe>

          <div className="ui checkbox mrbm" data-show={this.props.isPortalAdmin}>
            <input
              tabIndex="7"
              checked={this.props.groupForm.purgeCallerDetails}
              onChange={this.purgeCallerChanged}
              type="checkbox"
              name={APP.LANGUAGE.CreateUpdateGroup.PurgeCallerPlaceholder}
            />
            <label className="color-black">{APP.LANGUAGE.CreateUpdateGroup.PurgeCallerPlaceholder}</label>
          </div>

          <div data-show={!this.props.isPortalAdmin && this.props.groupForm.organisationNetworkId > 0}>
            <label className="color-black" data-show={this.props.groupForm.purgeCallerDetails}>
              {APP.LANGUAGE.ViewGroup.PurgeCallDetailsLabel}
            </label>
            <label className="color-black" data-show={!this.props.groupForm.purgeCallerDetails}>
              {APP.LANGUAGE.ViewGroup.DontPurgeCallDetailsLabel}
            </label>
          </div>
        </div>
      );
    }
    return <span>{elementsToRender}</span>;
  }
}

function mapStateToProps(state) {
  return {
    groupForm: state.groupsReducer.groupForm,
    videoCallQualityProfiles: state.portalSettingReducer.portalSetting.videoCallQualityProfiles,
    defaultVideoCallQuality: state.portalSettingReducer.portalSetting.defaultVideoCallQuality,
    isPortalAdmin: state.usersReducer.userProfile && state.usersReducer.userProfile.isPortalAdmin,
    groupNotificationEmail: state.usersReducer.userProfile.email,
    modalVisible: state.modalReducer.modalVisible,
  };
}
